import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {MUTATION_KEYS} from '@/queryClient'
import {HttpUpdateUserAvailabilityOptions, httpUpdateUserAvailability} from '../http/users-availability.http'
import {UserAvailability} from '../types'
import {AxiosError} from 'axios'
import {ErrorResponseData} from '@/types'

type UseUpdateUserAvailabilityOptions = {
    urlParams: HttpUpdateUserAvailabilityOptions['urlParams']
    options?: Omit<
        UseMutationOptions<UserAvailability, AxiosError<ErrorResponseData>, HttpUpdateUserAvailabilityOptions['data']>,
        'mutationFn' | 'mutationKey'
    >
}

export const useUpdateUserAvailability = ({urlParams, options}: UseUpdateUserAvailabilityOptions) => {
    return useMutation<UserAvailability, AxiosError<ErrorResponseData>, HttpUpdateUserAvailabilityOptions['data']>({
        mutationKey: [MUTATION_KEYS.UPDATE_USER_AVAILABILITY, urlParams.userId],
        mutationFn: async data => {
            const response = await httpUpdateUserAvailability({urlParams, data})
            return response.data as UserAvailability
        },
        ...options
    })
}
